module.exports = __webpack_public_path__ + "static/media/william_hsieh.89a7568a.png";